"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharingRuleValues = void 0;
exports.SharingRuleValues = ['manual', 'autoShare'];
